/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Ops_Desc3Inputs */

const en_svc_ai_integration_ops_desc3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version-controlled prompts, evals before deploys, and output-quality monitoring that keeps the feature honest.`)
};

const ar_svc_ai_integration_ops_desc3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برومتات مُصدَرة وتقييمات قبل النشر ومراقبة جودة المخرجات تُبقي الميزة صادقة.`)
};

const bn_svc_ai_integration_ops_desc3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভার্সন-কন্ট্রোলড প্রম্পট, ডিপ্লয়ের আগে ইভাল, এবং আউটপুট-কোয়ালিটি মনিটরিং, ফিচারটিকে সৎ রাখে।`)
};

const de_svc_ai_integration_ops_desc3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versionskontrollierte Prompts, Evals vor dem Deploy und Monitoring der Ausgabequalität, das das Feature ehrlich hält.`)
};

const es_svc_ai_integration_ops_desc3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompts con control de versiones, evaluaciones antes de los deploys y monitoreo de calidad que mantiene la función honesta.`)
};

const fr_svc_ai_integration_ops_desc3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompts versionnés, évaluations avant déploiement et surveillance de la qualité des résultats qui maintiennent la fonctionnalité honnête.`)
};

const pt_svc_ai_integration_ops_desc3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompts controlados por versão, avaliações antes da implantação e monitoramento da qualidade de saída que mantêm o recurso honesto.`)
};

const zh_svc_ai_integration_ops_desc3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`版本化的提示词、发布前评估，外加输出质量监控，让功能一直老实。`)
};

const tr_svc_ai_integration_ops_desc3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versiyonlu prompt'lar, deploy öncesi değerlendirmeler ve özelliği dürüst tutan çıktı kalitesi izleme.`)
};

const ru_svc_ai_integration_ops_desc3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промпты под версионным контролем, эвалы до деплоев и мониторинг качества вывода, держащий фичу честной.`)
};

const pl_svc_ai_integration_ops_desc3 = /** @type {(inputs: Svc_Ai_Integration_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompty pod kontrolą wersji, ewaluacje przed wdrożeniem i monitoring jakości outputu, który trzyma funkcję w ryzach.`)
};

/**
* | output |
* | --- |
* | "Version-controlled prompts, evals before deploys, and output-quality monitoring that keeps the feature honest." |
*
* @param {Svc_Ai_Integration_Ops_Desc3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_ops_desc3 = /** @type {((inputs?: Svc_Ai_Integration_Ops_Desc3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Ops_Desc3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_ops_desc3(inputs)
	if (locale === "bn") return bn_svc_ai_integration_ops_desc3(inputs)
	if (locale === "de") return de_svc_ai_integration_ops_desc3(inputs)
	if (locale === "es") return es_svc_ai_integration_ops_desc3(inputs)
	if (locale === "fr") return fr_svc_ai_integration_ops_desc3(inputs)
	if (locale === "pt") return pt_svc_ai_integration_ops_desc3(inputs)
	if (locale === "zh") return zh_svc_ai_integration_ops_desc3(inputs)
	if (locale === "tr") return tr_svc_ai_integration_ops_desc3(inputs)
	if (locale === "ru") return ru_svc_ai_integration_ops_desc3(inputs)
	if (locale === "pl") return pl_svc_ai_integration_ops_desc3(inputs)
	return en_svc_ai_integration_ops_desc3(inputs)
});
export { svc_ai_integration_ops_desc3 as "svc_ai-integration_OPS_desc" }